/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface PartnerModelRg {

        "emitterState"?: string;

        "number"?: number;

        "emissionDate"?: Date;

        "emitterOrgan"?: string;
    }

}
